import folders from '../../Actions/folders';
const { types } = folders;

const initialState = {
    folders: [
        { value: '1', label: 'Año de Emisión', pathName: 'AñoDeEmision', selected: false },
        { value: '2', label: 'Mes de Emisión', pathName: 'MesDeEmision', selected: false },
        { value: '3', label: 'Día de Emisión ', pathName: 'DiaDeEmision', selected: false },
        { value: '4', label: 'RFC Receptor', pathName: 'RFCReceptor', selected: false },
        { value: '5', label: 'RFC Emisor', pathName: 'RFCEmisor', selected: false },
        { value: '6', label: 'Serie', pathName: 'Serie', selected: false },
        { value: '7', label: 'Folio', pathName: 'Folio', selected: false },
        { value: '8', label: 'Estado', pathName: 'Estado', selected: false },
        { value: '9', label: 'Tipo de comprobante', pathName: 'TipoDeComprobante', selected: false },
    ],
    files: [
        { value: '1', label: 'UUID', pathName: 'UUID', selected: false },
        { value: '2', label: 'Fecha de Emisión', pathName: 'FechaDeEmision', selected: false },
        { value: '3', label: 'RFC Receptor', pathName: 'RFCReceptor', selected: false },
        { value: '4', label: 'RFC Emisor', pathName: 'RFCEmisor', selected: false },
        { value: '5', label: 'Serie', pathName: 'Serie', selected: false },
        { value: '6', label: 'Folio', pathName: 'Folio', selected: false },
        { value: '7', label: 'Total', pathName: 'Total', selected: false },
        { value: '8', label: 'Estado', pathName: 'Estado', selected: false },
        { value: '9', label: 'Tipo de comprobante', pathName: 'TipoDeComprobante', selected: false },
    ],
    filesSelected: [],
    foldersSelected: []
   
};

const foldersReducer = (state = initialState, action) => {

    switch (action.type) {
        
        case types.ADD_REMOVE_FOLDER_OPTION:    
            return {
                ...state,
                folders: action.data
            }
        case types.ADD_REMOVE_FILE_OPTION:    
            return {
                ...state,
                files: action.data
            }
        case types.SELECT_FILE:    
            return {
                ...state,
                filesSelected: action.data
            }
        case types.SELECT_FOLDER:    
            return {
                ...state,
                foldersSelected: action.data
            }
        default:
            return state;
    }
} 

export default foldersReducer;